// extracted by mini-css-extract-plugin
module.exports = {"heading":"headings_heading__1zeBI","inner":"headings_inner__2lBsu","line":"headings_line__V8nfN","active":"headings_active__2vmor"};